export const theme = {
    colors: {
        primary: '#70C618',
        primaryHover: '#85C441',
        ink: '#000000',
        inkInverse: '#FFFFFF',
        surface0: '#000000',
        surface1: '#0A0A0A',
        surface2: '#111111',
        surface3: '#2E2E2E',
        surfaceLight: '#FFFFFF',
        glass: '#EDE9DE1A',
        borderLight: 'rgba(0, 0, 0, 0.1)',
        borderDark: 'rgba(255, 255, 255, 0.14)',
        muted: '#777777',
        mutedLight: '#999999',
    },
    fonts: {
        display: '"Bebas Neue", Impact, sans-serif',
        heading: '"Montserrat", sans-serif',
        body: '"Public Sans", sans-serif',
    },
    radii: {
        pill: '999px',
        badge: '20px',
        field: '4px',
        media: '15px',
    },
    layout: {
        container: '1800px',
        pageGutter: '40px',
        headerHeight: '130px',
    },
    motion: {
        easeOut: 'cubic-bezier(0.25, 1, 0.2, 1)',
        durationUi: '450ms',
    },
}

export type AppTheme = typeof theme
